var _defs, _rect, _g, _line, _path, _line2, _g2, _path2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkelpMediaRelations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.37 93.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:1.02px;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{opacity:.65;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-6{stroke-miterlimit:10;}.cls-1,.cls-3,.cls-4{fill:none;stroke:#fff;stroke-linecap:round;}.cls-7{fill:#e9aa21;}.cls-8,.cls-2,.cls-6{fill:#fff;}.cls-2{stroke-width:1.18px;}.cls-2,.cls-6{stroke:#eaaa00;}.cls-3{stroke-width:.9px;}.cls-4{stroke-width:.65px;}.cls-6{stroke-width:1.09px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 10.02,
    y: 3.86,
    width: 85.85,
    height: 85.85,
    rx: 5.1,
    ry: 5.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m90.77,5.42c1.95,0,3.54,1.59,3.54,3.54v75.64c0,1.95-1.59,3.54-3.54,3.54H15.13c-1.95,0-3.54-1.59-3.54-3.54V8.96c0-1.95,1.59-3.54,3.54-3.54h75.64m0-1.56H15.13c-2.82,0-5.1,2.29-5.1,5.1v75.64c0,2.82,2.29,5.1,5.1,5.1h75.64c2.82,0,5.1-2.29,5.1-5.1V8.96c0-2.82-2.29-5.1-5.1-5.1h0Z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.16,
    y1: 78.63,
    x2: 56.74,
    y2: 78.63
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m59.45,67.8c0,3.59-2.91,6.5-6.5,6.5s-6.5-2.91-6.5-6.5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 52.95,
    y1: 75.08,
    x2: 52.95,
    y2: 77.67
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m52.95,43.58c7.89,0,14.31-6.42,14.31-14.31s-6.42-14.31-14.31-14.31-14.31,6.42-14.31,14.31,6.42,14.31,14.31,14.31Zm0-24.06c5.38,0,9.75,4.37,9.75,9.75s-4.37,9.75-9.75,9.75-9.75-4.37-9.75-9.75,4.37-9.75,9.75-9.75Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m64.81,49.4c5.4,0,9.8,4.4,9.8,9.8v14.84h4.94v-14.84c0-8.13-6.61-14.73-14.74-14.73h-8.38s-1.19,0-1.19,0h-14.16c-8.13,0-14.74,6.61-14.74,14.73v14.84s4.94,0,4.94,0v-14.84c0-5.4,4.4-9.8,9.8-9.8h23.73Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m53.71,62.98c0-.46.37-.83.83-.83h3.53v-1h-5.11c-.46,0-.83-.37-.83-.83s.37-.83.83-.83h5.11v-1h-3.53c-.46,0-.83-.37-.83-.83s.37-.83.83-.83h3.51c-.09-2.75-2.33-4.96-5.1-4.96s-5.12,2.29-5.12,5.12v10.33c0,2.83,2.29,5.12,5.12,5.12s5.12-2.29,5.12-5.12v-3.5h-3.53c-.46,0-.83-.37-.83-.83Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkelpMediaRelations);
export default __webpack_public_path__ + "static/media/SKELP_MediaRelations.ca69d990199dcc9b5c1addae6aca3bf5.svg";
export { ForwardRef as ReactComponent };